import React from "react";
import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import { ALLOWED_ADMINS } from "../../Pages/OurProduct/constants";
import "./style/CheckoutPage.css";

const AdminLogin = ({ adminUser, setAdminUser, adminPass, setAdminPass, onClose, onLoginSuccess, showToast }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const match = ALLOWED_ADMINS.find(
            (admin) => admin.username === adminUser && admin.password === adminPass
        );
        if (match) {
            const localizedName = adminUser.split("_")[0].toUpperCase();
            onLoginSuccess(localizedName);
            setAdminUser("");
            setAdminPass("");
            showToast(`Welcome back, ${localizedName}!`);
        } else {
            showToast("Security Violation: Invalid Credentials!");
        }
    };

    return (
        <div
            className="checkout-page"
            style={{
                backgroundColor: myCustomTheme.colors.header_footer_bg,
                boxShadow: myCustomTheme.shadows.hard,
                borderRadius: "24px",
                border: `1px solid ${myCustomTheme.colors.high_light}`
            }}
        >
            <button
                className="back-btn"
                onClick={onClose}
                style={{
                    backgroundColor: myCustomTheme.colors.button_bg,
                    color: myCustomTheme.colors.button_text
                }}
            >
                <FaArrowLeft /> Exit Security
            </button>

            <h1 style={{ color: myCustomTheme.colors.heading }}>Admin Verification Secure Gate</h1>

            <form onSubmit={handleSubmit} className="checkout-form">
                <div className="form-group">
                    <label className="input-label" style={{ color: myCustomTheme.colors.menu_text }}>
                        User Security ID
                    </label>
                    <input
                        type="text"
                        placeholder="Enter Admin Username"
                        value={adminUser}
                        onChange={(e) => setAdminUser(e.target.value)}
                        required
                        style={{
                            border: `1.5px solid ${myCustomTheme.colors.bg_secondary}`,
                            backgroundColor: myCustomTheme.colors.bg_primary,
                            color: myCustomTheme.colors.heading
                        }}
                    />
                </div>
                <div className="form-group">
                    <label className="input-label" style={{ color: myCustomTheme.colors.menu_text }}>
                        Security Access Password
                    </label>
                    <input
                        type="password"
                        placeholder="Enter System Password"
                        value={adminPass}
                        onChange={(e) => setAdminPass(e.target.value)}
                        required
                        style={{
                            border: `1.5px solid ${myCustomTheme.colors.bg_secondary}`,
                            backgroundColor: myCustomTheme.colors.bg_primary,
                            color: myCustomTheme.colors.heading
                        }}
                    />
                </div>
                <button
                    type="submit"
                    className="continue-btn"
                    style={{
                        backgroundColor: myCustomTheme.colors.button_bg,
                        color: myCustomTheme.colors.button_text,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px"
                    }}
                >
                    <FaShieldAlt /> Authorize &amp; Log In
                </button>
            </form>
        </div>
    );
};

export default AdminLogin;